<template>
  <div class="d-flex flex-column">
    <div class="d-flex gap-2 align-items-center">
      <div class="my-2">{{ title }}:</div>
      <button
          v-for="i in items" :key="i"
          class="btn btn-sm btn-outline-primary d-flex gap-2"
          type="button"
          :disabled="!$parent.edit"
          @click="$emit('item-delete', i)"
      >
        {{ formatItem ? formatItem(i) : i }}<i class="bi bi-x"/>
      </button>


      <button v-if="$parent.edit && !showPicker" class="btn btn-sm btn-primary" type="button" @click="showPicker=true">{{ button }}</button>
    </div>
    <std-table
        v-if="$parent.edit && showPicker"
        url="/users"
        :title="title"
        :format="format"
        :page-size="5"
        :do-emit="true"
        :close="true"
        @click-item="$emit('item-add', $event)"
        @click-close="showPicker=false"
    />
  </div>
</template>

<script>
import StdTable from "@/components/StdTable";

export default {
  components: {StdTable},
  props: [
    "title",
    "items",
    "source",
    "format",
    "button",
    "formatItem",
  ],
  emits: ["item-add", "item-delete"],
  data() {
    return {
      showPicker: false,
    }
  },

}
</script>

<style scoped>

</style>